import { render, staticRenderFns } from "./SystemMessageInfo.vue?vue&type=template&id=082fde42&scoped=true&"
import script from "./SystemMessageInfo.vue?vue&type=script&lang=js&"
export * from "./SystemMessageInfo.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageInfo.vue?vue&type=style&index=0&id=082fde42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082fde42",
  null
  
)

export default component.exports